import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import { EncomendaDto } from "core/features/encomenda/typings/index";
import moment from "moment";
import TagStatusEncomenda from "./components/TagStatusEncomenda/index";
function useEncomendaColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data de cadastro",
        key: "createdAt",
        width: "200px",
        render: (original: EncomendaDto) => (
          <Flex>{moment(original.createdAt).format("DD/MM/YYYY")}</Flex>
        ),
        sorter: true,
      },
      {
        title: "Unidade",
        key: "unidade",
        sorter: true,
        render: (original: EncomendaDto) => (
          <Flex>{original.unidade.numero}</Flex>
        ),
      },
      {
        title: "Morador",
        key: "pessoa",
        sorter: true,
        render: (original: EncomendaDto) => <Flex>{original.pessoa.nome}</Flex>,
      },
      {
        title: "Descrição",
        key: "descricao",
        sorter: true,
        render: (original: EncomendaDto) => <Flex>{original.descricao}</Flex>,
      },

      {
        title: "Data da chegada",
        key: "dataChegadaCondominio",
        sorter: true,
        render: (original: EncomendaDto) => (
          <Flex>
            {original.dataChegadaCondominio
              ? moment(original.dataChegadaCondominio).format(
                  "DD/MM/YYYY [às] HH:mm"
                )
              : "--"}
          </Flex>
        ),
      },
      {
        title: "",
        render: (original: EncomendaDto) => (
          <Flex>
            <TagStatusEncomenda status={original.status.nome} />
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useEncomendaColumns;
